import { Link, useLocation } from "react-router-dom";
import { useState, useEffect } from "react";
import styles from "./Sidebar.module.css";

const itemArr = [
  {
    href: "/",
    icon: <i className="bi bi-speedometer2"></i>,
    text: "Home"
  },
  {
    href: "#",
    icon: <i className="bi bi-images"></i>,
    text: "Assets",
    subItems: [
      {
        href: "/resources",
        icon: <i className="bi bi-layers"></i>,
        text: "Resources",
      },
      {
        href: "/files",
        icon: <i className="bi bi-archive"></i>,
        text: "Files"
      },
      {
        href: "/collections",
        icon: <i className="bi bi-collection"></i>,
        text: "Collections"
      },
    ]
  },
  {
    href: "#",
    icon: <i className="bi bi-flag"></i>,
    text: "Marketing",
    subItems: [
      {
        href: "/events",
        icon: <i className="bi bi-file-earmark-text"></i>,
        text: "Events"
      },
      {
        href: "/contacts",
        icon: <i className="bi bi-envelope"></i>,
        text: "Contacts"
      }
    ]
  },
  {
    href: "#",
    icon: <i className="bi bi-cart"></i>,
    text: "Sales",
    subItems: [
      {
        href: "/orders",
        icon: <i className="bi bi-box2"></i>,
        text: "Orders"
      },
      {
        href: "/payments",
        icon: <i className="bi bi-wallet"></i>,
        text: "Payments"
      },
    ]
  },
  {
    href: "/users",
    icon: <i className="bi bi-people"></i>,
    text: "Users"
  },
  {
    href: "#",
    icon: <i className="bi bi-graph-up-arrow"></i>,
    text: "Analytics & Reports",
    subItems: [
      {
        href: "/reports/seo",
        icon: <i className="bi bi-search-heart"></i>,
        text: "SEO Health"
      },
      {
        href: "/reports/file-summary",
        icon: <i className="bi bi-file-binary"></i>,
        text: "File Summary"
      },
      {
        href: "/reports/file-report",
        icon: <i className="bi bi-files"></i>,
        text: "File Analytics"
      },
      {
        href: "/reports/search",
        icon: <i className="bi bi-search"></i>,
        text: "Search Analytics"
      },
      {
        href: "/reports/tags",
        icon: <i className="bi bi-tags"></i>,
        text: "Tag Management"
      },
      {
        href: "/reports/meta",
        icon: <i className="bi bi-globe"></i>,
        text: "SEO URLs"
      },
      {
        href: "/reports/replace-tags",
        icon: <i className="bi bi-arrow-left-right"></i>,
        text: "Replace Tags"
      },
      {
        href: "/convert",
        icon: <i className="bi bi-arrow-repeat"></i>,
        text: "File Converter"
      }
    ]
  },
  {
    href: "#",
    icon: <i className="bi bi-tools"></i>,
    text: "Tools",
    subItems: [
      {
        href: "/resources/search",
        icon: <i className="bi bi-image"></i>,
        text: "Search Similar by Image"
      },
      {
        href: "/resources/similar?resource_id=622037171c1231757ac8a80b",
        icon: <i className="bi bi-search"></i>,
        text: "Search Similar by Resource ID"
      }
    ]
  },
];

const Sidebar = ({ show }) => {
  const location = useLocation();
  const [expandedItems, setExpandedItems] = useState({});

  useEffect(() => {
    // Automatically expand the menu if the current path matches a subItem
    const newExpandedItems = {};
    itemArr.forEach((item, index) => {
      if (item.subItems) {
        const isActive = item.subItems.some(subItem => location.pathname.startsWith(subItem.href));
        newExpandedItems[index] = isActive;
      }
    });
    setExpandedItems(newExpandedItems);
  }, [location.pathname]);

  const toggleSubmenu = (index) => {
    setExpandedItems(prev => ({
      ...prev,
      [index]: !prev[index]
    }));
  };

  const isActive = (href) => location.pathname.startsWith(href);

  return (
    <div className={`sidebar ${styles.sidebar} ${show ? 'show' : ''}`}>
      <div className={`${styles.wrapper} sidebar-content`}>
        <div className={styles.logoWrapper}>
          <Link to="/" className={`w-100 `}>
            <img
              src="/m_logo_2_sm.svg"
              alt="Magipik Backend"
              className={styles.logoImg}
            />
          </Link>
        </div>
        <ul className="nav flex-column mt-4 mb-auto">
          {itemArr.map((item, index) => (
            <li
              className={`nav-item ${isActive(item.href) ? styles.active : ""}`}
              key={index}
            >
              {item.subItems ? (
                <>
                  <div 
                    className={`${styles.itemLink} ${styles.parentItem}`}
                    onClick={() => toggleSubmenu(index)}
                  >
                    <span className="me-3">{item.icon}</span>
                    <span className={`item-name ${show ? "d-block opacity-1000" : "d-none opacity-0"}`}>
                      {item.text}
                    </span>
                    <i className={`bi bi-chevron-${expandedItems[index] ? 'down' : 'right'} ms-auto ${show ? "" : "d-none"}`}></i>
                  </div>
                  {expandedItems[index] && show && (
                    <ul className={styles.submenu}>
                      {item.subItems.map((subItem, subIndex) => (
                        <li
                          key={subIndex}
                          className={isActive(subItem.href) ? styles.active : ""}
                        >
                          <Link to={subItem.href} className={styles.subItemLink}>
                            <span className="me-2">{subItem.icon}</span>
                            <span>{subItem.text}</span>
                          </Link>
                        </li>
                      ))}
                    </ul>
                  )}
                </>
              ) : (
                <Link to={item.href} className={`${styles.itemLink} ${isActive(item.href) ? styles.active : ""}`}>
                  <span className="me-3">{item.icon}</span>
                  <span className={`item-name ${show ? "d-block opacity-1000" : "d-none opacity-0"}`}>
                    {item.text}
                  </span>
                </Link>
              )}
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default Sidebar;
